<script lang="ts">
  import { page } from '$app/stores';
  import Footer from '$components/footer/Footer.svelte';
  import Main from '$components/layout/Main.svelte';
  import NavBar from '$components/menu/NavBar.svelte';
  import Dashboard from '$components/modals/Dashboard.svelte';
  import DashboardSettings from '$components/modals/DashboardSettings.svelte';
  import DonationPledge from '$components/modals/DonationPledge.svelte';
  import Login from '$components/modals/Login.svelte';
  import Youtube from '$components/modals/Youtube.svelte';
  import ModalWrapper from '$components/utils/ModalWrapper.svelte';
  import {
    english,
    showDashboard,
    showDashboardSettings,
    showLogin,
    showPledge
  } from '$lib/stores';
  import '$src/styles/global.scss';

  page.subscribe((value) => {
    english.set(value.url.pathname.startsWith('/en'));
  });
</script>

<Login />
<DonationPledge />
<Dashboard />
<DashboardSettings />
<Youtube />

<ModalWrapper showModal={$showLogin || $showPledge || $showDashboard || $showDashboardSettings}>
  <NavBar
    login={() => {
      showLogin.set(true);
    }}
  />
  <Main>
    <slot />
  </Main>
</ModalWrapper>
<Footer />
